module.exports = __webpack_public_path__ + "assets/img/logo-paypal.59185e3c.svg";